'use client';
import React from 'react';

const features = [
  {
    icon: '🗺️',
    title: 'Live order tracking',
    description: 'Watch your rider move in real time on the map. No more guessing — you\'ll know exactly when to open the door.',
    badge: { text: '🚴 Rider 2.3 km away · 6 min', color: '#f97316', bg: '#1a0e00', border: '#3d2000' },
    wide: true,
    bg: 'linear-gradient(135deg, #1a0e00 0%, #0d0700 100%)',
    border: '#2d1a00',
  },
  {
    icon: '🏪',
    title: '1,200+ local vendors',
    description: 'From your corner jollof spot to the new ramen bar downtown.',
    wide: false,
    bg: '#111111',
    border: '#222',
  },
  {
    icon: '🎁',
    title: 'Rewards on every order',
    description: 'Earn Mdeliva Points. Redeem for free meals and discounts.',
    wide: false,
    bg: '#111111',
    border: '#222',
  },
  {
    icon: '⚡',
    title: 'Order in under 60 seconds',
    description: 'Saved addresses, remembered preferences, and one-tap reorders make hunger a non-event.',
    wide: true,
    bg: '#111111',
    border: '#222',
  },
  {
    icon: '🔒',
    title: 'Secure payments',
    description: 'Card, wallet, mobile money, or cash — always protected.',
    wide: false,
    bg: '#111111',
    border: '#222',
  },
  {
    icon: '🚴',
    title: 'Earn as a rider',
    description: 'Flexible hours, daily payouts, and bonus rewards.',
    wide: false,
    bg: '#111111',
    border: '#222',
  },
];

export default function WhyMdeliva() {
  return (
    <section id="vendors" className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Section Label */}
        <div className="mb-6">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest bg-[#0a1a0a] border border-[#1a3a1a] text-[#22c55e]">
            WHY MDELIVA
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10">
          Built for real hunger.
        </h2>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Wide card - Live order tracking */}
          <div
            className="md:col-span-2 rounded-2xl p-6 border"
            style={{ background: features?.[0]?.bg, borderColor: features?.[0]?.border }}
          >
            <div className="text-3xl mb-3">{features?.[0]?.icon}</div>
            <h3 className="text-white font-bold text-lg mb-2">{features?.[0]?.title}</h3>
            <p className="text-gray-400 text-sm mb-4 max-w-lg">{features?.[0]?.description}</p>
            {features?.[0]?.badge && (
              <span
                className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium"
                style={{
                  color: features?.[0]?.badge?.color,
                  backgroundColor: features?.[0]?.badge?.bg,
                  border: `1px solid ${features?.[0]?.badge?.border}`,
                }}
              >
                {features?.[0]?.badge?.text}
              </span>
            )}
          </div>

          {/* 1,200+ local vendors */}
          <div
            className="rounded-2xl p-6 border"
            style={{ background: features?.[1]?.bg, borderColor: features?.[1]?.border }}
          >
            <div className="text-3xl mb-3">{features?.[1]?.icon}</div>
            <h3 className="text-white font-bold text-base mb-2">{features?.[1]?.title}</h3>
            <p className="text-gray-400 text-sm">{features?.[1]?.description}</p>
          </div>

          {/* Rewards */}
          <div
            className="rounded-2xl p-6 border"
            style={{ background: features?.[2]?.bg, borderColor: features?.[2]?.border }}
          >
            <div className="text-3xl mb-3">{features?.[2]?.icon}</div>
            <h3 className="text-white font-bold text-base mb-2">{features?.[2]?.title}</h3>
            <p className="text-gray-400 text-sm">{features?.[2]?.description}</p>
          </div>

          {/* Order in 60s - wide */}
          <div
            className="md:col-span-2 rounded-2xl p-6 border"
            style={{ background: features?.[3]?.bg, borderColor: features?.[3]?.border }}
          >
            <div className="text-3xl mb-3">{features?.[3]?.icon}</div>
            <h3 className="text-white font-bold text-base mb-2">{features?.[3]?.title}</h3>
            <p className="text-gray-400 text-sm max-w-lg">{features?.[3]?.description}</p>
          </div>

          {/* Secure payments */}
          <div
            className="rounded-2xl p-6 border"
            style={{ background: features?.[4]?.bg, borderColor: features?.[4]?.border }}
          >
            <div className="text-3xl mb-3">{features?.[4]?.icon}</div>
            <h3 className="text-white font-bold text-base mb-2">{features?.[4]?.title}</h3>
            <p className="text-gray-400 text-sm">{features?.[4]?.description}</p>
          </div>

          {/* Earn as a rider */}
          <div
            className="rounded-2xl p-6 border"
            style={{ background: features?.[5]?.bg, borderColor: features?.[5]?.border }}
          >
            <div className="text-3xl mb-3">{features?.[5]?.icon}</div>
            <h3 className="text-white font-bold text-base mb-2">{features?.[5]?.title}</h3>
            <p className="text-gray-400 text-sm">{features?.[5]?.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
